import React from 'react';
import { ButtonProps } from '@cardboard-ui/react';
import { EllipsisHIcon } from 'components/icons';
import { OptionsMenuButton } from 'components/OptionsMenu/OptionsMenuButton';

export const ItemMenuButton = ({ onClick }: ButtonProps) => {
  return (
    <OptionsMenuButton
      icon={<EllipsisHIcon />}
      size="sm"
      variant="ghost"
      colorScheme="gray"
      onClick={onClick}
    />
  );
};
